export default __webpack_public_path__ + "static/media/inline5.314a2edc.png";